export const build = { date:"2026-05-27.1448", stage:"alpha" }
